import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Home as HomeIcon, ArrowLeft } from "lucide-react";

export default function NotFound() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div className="pt-[148px] min-h-screen flex items-center justify-center px-5" data-testid="not-found-page">
      <div className="text-center max-w-lg">
        <p className="font-display font-black tracking-tight leading-none" style={{ fontSize: "8rem", color: "var(--orange)" }}>404</p>
        <h1 className="font-display font-bold text-3xl sm:text-4xl mt-2 mb-4">Page introuvable</h1>
        <p className="text-lg mb-8" style={{ color: "var(--ink-2)" }}>
          La page que vous cherchez n'existe pas ou a été déplacée. Retrouvez nos produits, formations et conseils depuis l'accueil.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/" className="btn-primary px-8 py-4 font-semibold flex items-center justify-center gap-2" data-testid="notfound-home-btn"><HomeIcon size={18} /> Retour à l'accueil</Link>
          <Link to="/catalogue" className="btn-outline px-8 py-4 font-semibold flex items-center justify-center gap-2"><ArrowLeft size={18} /> Voir le catalogue</Link>
        </div>
      </div>
    </div>
  );
}
